import store from '../store';
import config from '../config/app';
import { getAccountId, getAccountState, getUserRole } from '../redux/fe-data/selectors';

export const CLICKED_NURTURE_BANNER = 'Clicked Nurture Bar Banner';
export const CLICKED_UPGRADE_BANNER = 'Clicked Upgrade Now banner';
export const CLICKED_NURTURE_BAR_POPUP = 'Clicked Nurture Bar Popup';
export const NURTURE_BAR_POPUP = 'Nurture Bar Popup';
export const NURTURE_BAR_TYPES = {
  accountOwner: 'trial', // This is left as 'trial' for segment track continuity between versions.
  freemium: 'freemium',
  responder: 'responder',
};

export const trackEvent = (track, properties) => {
  const state = store.getState();

  window.pdAnalytics.track(track, {
    groupId: getAccountId(state),
    account_state: getAccountState(state),
    user_role: getUserRole(state),
    nurtureBarVersion: config.SEGMENT_TRACK_VERSION,
    ...properties
  });
};

export default trackEvent;
